const API_BASE = import.meta.env.VITE_API_BASE_URL ?? "";
const TOKEN_KEY = "mediste-commerce-admin-token";

export const session = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (token: string) => localStorage.setItem(TOKEN_KEY, token),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const headers = new Headers(init?.headers);
  if (!(init?.body instanceof FormData)) headers.set("content-type", "application/json");
  const token = session.get();
  if (token) headers.set("authorization", `Bearer ${token}`);
  const response = await fetch(`${API_BASE}${path}`, { ...init, headers });
  const result = await response.json().catch(() => ({ message: "服务返回了无法解析的数据" })) as T & { message?: string };
  if (!response.ok) {
    if (response.status === 401) session.clear();
    throw new Error(result.message ?? `请求失败（${response.status}）`);
  }
  return result;
}

export const formatMoney = (fen: number) => `¥${(fen / 100).toLocaleString("zh-CN", { minimumFractionDigits: 2 })}`;
